var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0A033C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8399 20.14L15.0999 18.835L13.1649 16.9L15.0999 14.965L13.8399 13.66L10.5999 16.9L13.8399 20.14ZM18.1599 20.14L21.3999 16.9L18.1599 13.66L16.8999 14.965L18.8349 16.9L16.8999 18.835L18.1599 20.14ZM9.6999 25C9.2049 25 8.781 24.8236 8.4282 24.4708C8.0754 24.118 7.8993 23.6944 7.8999 23.2V10.6C7.8999 10.105 8.0763 9.6811 8.4291 9.3283C8.7819 8.9755 9.2055 8.7994 9.6999 8.8H13.4799C13.6749 8.26 14.0013 7.825 14.4591 7.495C14.9169 7.165 15.4305 7 15.9999 7C16.5699 7 17.0838 7.165 17.5416 7.495C17.9994 7.825 18.3255 8.26 18.5199 8.8H22.2999C22.7949 8.8 23.2188 8.9764 23.5716 9.3292C23.9244 9.682 24.1005 10.1056 24.0999 10.6V23.2C24.0999 23.695 23.9235 24.1189 23.5707 24.4717C23.2179 24.8245 22.7943 25.0006 22.2999 25H9.6999ZM15.9999 9.925C16.1949 9.925 16.356 9.8611 16.4832 9.7333C16.6104 9.6055 16.6743 9.4444 16.6749 9.25C16.6749 9.055 16.611 8.8939 16.4832 8.7667C16.3554 8.6395 16.1943 8.5756 15.9999 8.575C15.8049 8.575 15.6438 8.6389 15.5166 8.7667C15.3894 8.8945 15.3255 9.0556 15.3249 9.25C15.3249 9.445 15.3888 9.6061 15.5166 9.7333C15.6444 9.8605 15.8055 9.9244 15.9999 9.925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame1.edb5ef6e201abdf3570711a044b16857.svg";
export { ForwardRef as ReactComponent };